import { render, staticRenderFns } from "./RuleCreateDialog.vue?vue&type=template&id=6df543aa&scoped=true"
import script from "./RuleCreateDialog.vue?vue&type=script&lang=ts"
export * from "./RuleCreateDialog.vue?vue&type=script&lang=ts"
import style0 from "./RuleCreateDialog.vue?vue&type=style&index=0&id=6df543aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df543aa",
  null
  
)

export default component.exports